import React, { Component } from 'react';
import Autosuggest from 'react-autosuggest';
import './CompanyAutoComplete.css';

class UserAutocomplete extends Component {
  constructor(props) {
    super(props);
    const searchTerm = props.searchTerm || '';
    this.state = {
      searchTerm,
      suggestions: this.filterUsers(searchTerm),
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.searchTerm !== prevProps.searchTerm) {
      this.setState({ searchTerm: this.props.searchTerm || '' });
    }
  }

  filterUsers = value => {
    const inputValue = value.trim().toLowerCase();
    const inputLength = inputValue.length;
    const { users } = this.props;
    return users.filter(user => user.email.toLowerCase().slice(0, inputLength) === inputValue);
  };

  getUserValue = user => user.email;

  renderSuggestion = user => <div>{user.email}</div>;

  onChange = (event, { newValue }) => {
    if (newValue === '') {
      this.props.onChange({ name: 'email', value: null, suggestion: null });
    }
    this.setState({
      searchTerm: newValue,
    });
  };

  // Autosuggest will call this function every time you need to update suggestions.
  // You already implemented this logic above, so just use it.
  onSuggestionsFetchRequested = ({ value }) => {
    this.setState({
      suggestions: this.filterUsers(value),
    });
  };

  // Autosuggest will call this function every time you need to clear suggestions.
  onSuggestionsClearRequested = () => {
    this.setState({
      suggestions: [],
    });
  };

  onUserSelected = (ev, { suggestion, suggestionValue }) => {
    const evObj = { name: 'user', value: suggestionValue, suggestion };
    this.props.onChange(evObj);
  };

  onKeyPress = e => {
    if (e.key === 'Enter') {
      const { users, userAutocomplete } = this.props;
      let suggestion = !userAutocomplete
        ? users.filter(item => item.email === e.currentTarget.value)
        : users.filter(item => item.email === e.currentTarget.value);
      this.props.onChange({
        name: 'user',
        value: e.currentTarget.value,
        suggestion: { ...suggestion[0] },
      });
    }
  };

  render() {
    const { searchTerm, suggestions } = this.state;

    // Autosuggest will pass through all these props to the input.
    const inputProps = {
      placeholder: 'Search User...',
      value: searchTerm,
      onChange: this.onChange,
      onKeyPress: this.onKeyPress,
      name: 'user',
      requires: 'true',
      type: 'text',
      className: 'form-control',
    };

    // Finally, render it!
    return (
      <div className={this.props.className || ''}>
        <Autosuggest
          suggestions={suggestions}
          onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
          onSuggestionsClearRequested={this.onSuggestionsClearRequested}
          getSuggestionValue={this.getUserValue}
          renderSuggestion={this.renderSuggestion}
          inputProps={inputProps}
          shouldRenderSuggestions={() => true}
          onSuggestionSelected={this.onUserSelected}
        />
      </div>
    );
  }
}

export default UserAutocomplete;
